/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { imagesGetMetadata } from "../../funcs/imagesGetMetadata.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetImageMetadataRequest$inboundSchema,
};

export const tool$imagesGetMetadata: ToolDefinition<typeof args> = {
  name: "images-get-metadata",
  description: `Retrieve metadata for a specific image by its ID.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await imagesGetMetadata(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
